export default {
    text1: '開戶領取獎勵',
    text2: '前往星財富',
    text3: '復星財富 x Mylink獨家禮遇',
    text4: '領取成功',
    text5: '領取失敗',
    text6: '活動不存在',
    text7: '活動不爲发佈狀態',
    text8: 'uin不存在',
    text9: '用戶不存在',
    text10: '已經領取過',
    text11: '此活動不適用於閣下之賬戶',
}
